module.exports = __webpack_public_path__ + "Flag-275.db1adf6729a701d6fdeca94394850c1e.svg";